import { motion } from 'framer-motion';
import { Home, Bot, ShoppingBag, User } from 'lucide-react';

interface BottomNavProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

export function BottomNav({ currentPage, onNavigate }: BottomNavProps) {
  const navItems = [
    { id: 'home', label: 'หน้าแรก', icon: Home },
    { id: 'bridgelet', label: 'AI Partner', icon: Bot },
    { id: 'deals', label: 'ดีล', icon: ShoppingBag },
    { id: 'profile', label: 'โปรไฟล์', icon: User },
  ];

  return (
    <motion.nav
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 glass border-t border-white/20 z-50"
      style={{
        paddingBottom: 'max(env(safe-area-inset-bottom), 0.5rem)',
      }}
    >
      <div className="flex items-center justify-around px-4 pt-3 pb-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPage === item.id;

          return (
            <motion.button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              whileTap={{ scale: 0.9 }}
              className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-all min-w-[64px] ${
                isActive
                  ? 'bg-teal-500/20 text-teal-300'
                  : 'text-white/60 hover:text-white/80'
              }`}
            >
              <div className="relative">
                <Icon className="w-6 h-6" />
                {isActive && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-teal-300"
                  />
                )}
              </div>
              <span className={`text-xs font-medium ${isActive ? 'text-teal-300' : 'text-white/60'}`}>
                {item.label}
              </span>
            </motion.button>
          );
        })}
      </div>
    </motion.nav>
  );
}
